export default (siteName) => [
    {
        path: 'special-disbursement-project',
        name: 'special-disbursement-project',
        component: () => import('../../components/dashboard/Finance/SpecialProject/index'),
        meta: {
            title: `特定費用設定${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'special-disbursement-project/:sno/',
        name: 'special-disbursement-project-detail',
        component: () => import('../../components/dashboard/Finance/SpecialProject/index'),
        meta: {
            title: `特定費用項目明細${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'special-disbursement-project/add',
        name: 'special-disbursement-project-add',
        component: () => import('../../components/dashboard/Finance/SpecialProject/EditPage'),
        meta: {
            title: `新增特定費用項目${siteName}`,
            activeMenu: 'settings',
        },
    },
    {
        path: 'special-disbursement-project/:sno/edit',
        name: 'special-disbursement-project-edit',
        component: () => import('../../components/dashboard/Finance/SpecialProject/EditPage'),
        meta: {
            title: `編輯特定費用項目${siteName}`,
            activeMenu: 'settings',
        },
    },
];
